import { getLink } from "../../../utils/utils";

import translator from "./translator";

const content = {
	esp: (
		`
		<p class="mb-5 text-center"><i>(memore al Ivan Sergeeviĉ Turgenev)</i></p>
		

		<p class="mb-3 text-center bold">1</p>

		<p class="mb-3">
			- Je la nomo de lia Imperiestra Moŝto, la Imperiestro Petro la Unua, mi proklamas revizion al tiu ĉi frenezula azilo!
		</p>

		<p class="mb-3">
			Tiuj vortoj estis diritaj per laŭta, akuta, sonora voĉo. 
			Skribisto de la malsanulejo, enskribanta la malsanulon en grandan trivitan libron sur la inkmakulita tablo, ne povis sin deteni de rideto. 
			Sed du junuloj, kondukintaj la malsanulon, ne ridis: ili apenaŭ tenis sin surgambe post du diurnoj sendormaj, vid-al-vide kun la frenezulo, kiun ili ĵus alveturigis fervoje. 
			En la antaŭlasta stacio la furiozeco de atakoj potenciĝis; ie oni trovis la frenezulan ĉemizon kaj, vokinte konduktorojn kaj ĝendarmon, surmetis ĝin sur la malsanulon. 
			Tiel oni alkondukis lin en la urbon, tiel ankaŭ liveris lin al malsanulejo.
		</p>

		<p class="mb-3">
			Li aspektis terure. 
			Super la disŝirita dum malsanatako en pecojn griza vesto, la jako el kruda tolo kun larĝa senkolumo strikte tegis lian staturon; longaj manikoj alpremis liajn brakojn krucforme al brusto kaj estis noditaj surdorse. 
			Ekscititaj, larĝe malfermitaj okuloj (li ne dormis dek noktojn) brilis per konstanta febra brilo; hirta bukla hararo sovaĝe falis surfrunten; li per rapidaj pezaj paŝoj pasadis de unu angulo de la akceptejo al la alia, esploreme ekzamenante per rigardo malnovajn ŝrankojn kun dokumentoj kaj tegitajn per laktolo seĝojn, kaj foj-de-foje ĵetante rigardon al siaj akompanintoj.
		</p>

		<p class="mb-3">
			-Alvenigu lin al la sekcio. 
			Dekstren.
		</p>

		<p class="mb-3">
			- Mi scias, scias. 
			Mi jam estis ĉi tie kun vi en la lasta jaro. 
			Ni pririgardis la malsanulejon. 
			Mi ĉion scias, kaj estos malfacile min trompi, - diris la malsanulo.
		</p>

		<p class="mb-3">
			Li turnis sin al la pordo. 
			La gardisto malfermis ĝin antaŭ li; per la sama rapida, peza kaj decidema paŝmaniero, alte levinte la alienan kapon, li eliris el la akceptejo kaj preskaŭ kurante ekiris dekstren, al frenezula sekcio. 
			La kondukantoj apenaŭ sukcesis lin sekvi.
		</p>

		<p class="mb-3">
			-Sonorigu. 
			Mi ne povas. 
			Vi kunligis miajn brakojn.
		</p>

		<p class="mb-3">
			La pordisto malfermis la pordon, kaj la irantoj enpaŝis en la malsanulejon.
		</p>

		<p class="mb-3">
			Tio estis granda ŝtona konstruaĵo, farita laŭ malnova oficeja maniero. 
			Du grandaj haloj, unu el ili – manĝejo, alia – komuna ĉambrego por trankvilaj malsanuloj, vasta koridoro kun vitra pordo kondukanta al ĝardeno kun floroj, kaj ĉirkaŭ dudek apartaj ĉambroj, kie loĝis malsanuloj, okupis la malsupran etaĝon; ankaŭ ĉi tie estis aranĝitaj du senlumaj ĉambroj, unu tegita de matracoj, alia – de lignaj tabuloj, kien oni lokigis rabiajn malsanulojn, kaj grandega mornaspekta ejo kun volboj – la banejo. 
			La supran etaĝon okupis virinoj. 
			Malagorda bruo, interrompata per hurloj kaj ĝemoj, fluis de tie. 
			La malsanulejo estis aranĝita por okdek personoj, sed, ĉar ĝi sola servis por kelkaj apudaj gubernioj, en ĝi oni foje lokigis eĉ tricent. 
			En malgrandaj kameroj staris po kvar kaj po kvin litoj; vintre, kiam oni ne lasis malsanulojn promeni en la ĝardeno kaj ĉiuj fenestroj post feraj kradoj estis strikte fermitaj, en la malsanulejo estis neelteneble sufoke.
		</p>

		<p class="mb-3">
			La novan malsanulon oni venigis al la ĉambro, kie troviĝis bankuvoj. 
			Eĉ al sana persono ĝi povus impresi deprimige; des pli peze ĝi influis al disakordita, ekzalta fantazio. 
			Tio estis granda ejo kun volboj, kun kotkovrita ŝtona planko, prilumita per nur unu fenestro, troviĝanta en angulo; la muroj kaj volba plafono estis farbitaj per malhelruĝa olefarbo; en nigriĝinta pro koto planko, samnivele kun ĝi, estis enigitaj du ŝtonaj bankuvoj, kiel du ovalaj, plenaj da akvo kavoj. 
			Enorma kupra stovo kun cilindroforma kaldrono por varmigo de akvo kaj komplika sistemo de kupraj tubetoj kaj kranoj okupis la angulon kontraŭ la fenestro. 
			Ĉio havis iun karakteron, eksterordinare misteran kaj mornan por malagordita kapo, kaj gardisto, kiu administris la banejon, ĉiam silenta ukrainano, per sia moroza mieno nur pliigis la impreson.
		</p>

		<p class="mb-3">
			Kaj kiam la malsanulon oni venigis al tia timiga ejo por banigi kaj, konforme al kuracsistemo de la ĉefdoktoro, fari al li sangosuĉan aplikaĵon sur la nuko, lin kaptis teruro kaj rabio. 
			Makabraj pensoj, unu pli bizara ol alia, eksvarmis en lia kapo. 
			Kio estas tio? 
			Ĉu Inkvizicio? Ĉu loko de sekreta ekzekuto, kie malamikoj liaj decidis finigi lian vivon? 
			Eble, tio estas la infero mem? 
			Fin-fine, al lia kapo venis ideo, ke estas iu elprovo. 
			Oni malvestis lin, malgraŭ lia furioza rezisto. 
			Kun duobliĝinta pro la malsano forto li facile liberiĝadis el la brakoj de kelkaj gardistoj, tiel ke ili faladis planken; fin-fine, kvaropo da ili faligis lin kaj, preninte je brakoj kaj gamboj, mergis lin en varmetan akvon. 
			Ĝi ŝajnis al li bolanta, kaj en vezania kapo traflugis konfuza kaj malkontinua ideo pri la provo per bolanta akvo kaj inkandeska fero. 
			Sufokiĝante pro akvo kaj konvulsie baraktante per brakoj kaj gamboj, je kiuj lin firme tenis la gardistoj, li singulte elkriis senordan parolon, kiun ne eblas imagi, se oni ne estis aŭdinta ĝin reale. 
			Estis en ĝi kaj preĝoj, kaj damnoj. 
			Li kriis ĝis kiam tute elĉerpiĝis liaj fortoj, kaj fine eldiris mallaŭte, kun varma ploro, la frazon, tute ne kongruan kun la antaŭa parolado:
		</p>

		<p class="mb-3">
			- Sankta martiro Georgij! 
			Al manoj viaj destinas mi la korpon mian. 
			Sed la spiriton – ne, ho ne!
		</p>

		<p class="mb-3">
			La gardistoj ankoraŭ estis tenantaj lin, kvankam li jam trankviliĝis. 
			La varma bano kaj plena da glacio ujo, metita sur la kapo, efikis kiel estis planite. 
			Sed kiam oni forprenis lin, preskaŭ senkonscian, el la akvo kaj sidigis sur tabureton por apliki sangosuĉilon, en li denove eksplodis la restintaj fortoj kaj frenezaj pensoj.
		</p>

		<p class="mb-3">
			- Pro kio? 
			Pro kio? 
			– kriis li. 
			– Mi al neniu deziris malbonon. 
			Pro kio min mortigi? 
			Ho-o-o-o! 
			Ho Dio! 
			Ho vi, torturitaj antaŭ mi! 
			Mi petegas vin, min savu…
		</p>

		<p class="mb-3">
			La brulakrega ektuŝo al la nuko elvokis furiozajn konvulsiojn. 
			La gardistoj ne povis deteni lin kaj ne sciis, kion fari.
		</p>

		<p class="mb-3">
			- Nenio plu restas, - diris la manupulinta soldato. 
			– Oni devas forigi.
		</p>

		<p class="mb-5">
			Tiuj simplaj vortoj tremigis la malsanulon. «Forigi! 
			Kion forigi? 
			Kiun forigi? 
			Min!» – pensis li kaj en morta teruro fermis okulojn. 
			La soldato prenis krudan viŝtukon je ambaŭ ekstremoj kaj kun forta premo rapide movis ĝin laŭ la nuko, forskrapante kaj la aplikaĵon, kaj la supran tavolon de la haŭto kaj lasinte sur ĝi sangantan ruĝan ekskoriaĵon. 
			La doloro de tiu operacio, neeltenebla eĉ por trankvila kaj sana persono, ekŝajnis al la malsanulo la fino de ĉio. 
			Li rabie elanis per la tuta korpo, elŝiriĝis el la brakoj de l’ gardistoj, kaj lia nuda korpo ekruliĝis sur ŝtonaj platoj. 
			Li pensis, ke oni forhakis lian kapon. 
			Li volis krii kaj ne povis. 
			Oni alportis lin al la lito, kaj lia sveno poiomete transformiĝis en profundan, longan, kvazaŭ mortan dormon.
		</p>


		<p class="mb-5 mt-5 text-center bold">2</p>


		<p class="mb-3">
			Li rekonsciiĝis nokte. Ĉio silentis ĉirkaŭe; el najbara granda ĉambro aŭdeblis spirado de dormantaj malsanuloj. 
			Ie malproksime, per monotona stranga voĉo parolis al si mem malsanulo, kiu estis lokigita por nokto en senluman ĉambron; kaj supre, en virina subsekcio, raŭka kontralto kantis iun sovaĝan kanton. 
			La malsanulo atente aŭskultis ĉi-sonojn. 
			Li sentis teruran feblon kaj lacdoloron en la tuta korpo; lia kolo forte doloris.
		</p>

		<p class="mb-3">
			- Kie mi? 
			Kio al mi? 
			– venis al lia kapo. 
			Kaj subite, kun eksterordinara klareco, aperis antaŭ li la lasta monato de lia vivo, kaj li komprenis, ke li estas malsana, kaj je kio malsana. 
			Vico da absurdaj pensoj, vortoj kaj agoj venis al lia memoro, elvokante tremon de la tuta lia memo.
		</p>

		<p class="mb-3">
			- Sed tio finiĝis, dank’ al Dio, tio finiĝis! 
			– flustris li kaj denove ekdormis.
		</p>

		<p class="mb-5">
			La malfermita fenestro kun fera krado rigardis al malgranda anguleto inter grandaj konstruaĵoj kaj ŝtona barilo; al tiu anguleto neniam iu venis, kaj ĝi plene kovriĝis per iu sovaĝa arbusto kaj siringo, pompe floranta en tiu sezono… Post la arbustoj, ĝuste kontraŭ la fenestro, staris en ombro alta barilo; altaj pintoj de arboj, aspergitaj kaj penetritaj per luna lumo, videblis post ĝi. 
			Dekstre altiĝis la konstruaĵo de la malsanulejo kun la fere kraditaj fenestroj, lumigitaj elinterne; maldekstre – blanka, brilanta pro lunlumo, senfenestra muro de kadavrejo. 
			La lunradioj penetris tra la fenestra krado en la ĉambron, falis surplanken kaj prilumis parton de la lito kaj mortlacigitan palan vizaĝon de la malsanulo kun fermitaj okuloj; nun en ĝi estis nenio aliena. 
			Estis profunda, prema dormo de multe suferinta homo, sen sonĝoj, sen ajna moviĝo kaj preskaŭ senspira. 
			Dum kelka tempo li vekiĝis plenkonscia, kvazaŭ sana, por ellitiĝi morgaŭ same freneza.
		</p>


		<p class="mb-5 mt-5 text-center bold">3</p>


		<p class="mb-3">
			- Kiel vi fartas? 
			– demandis lin sekvatage la doktoro.
		</p>

		<p class="mb-3">
			La malsanulo, ĵus vekiĝinta, ankoraŭ kuŝis sub kovrilo.
		</p>

		<p class="mb-3">
			- Bonege! 
			– respondis li, elsaltante el la lito, surmetante pantoflojn kaj rapide prenante ĥalaton. 
			– Perfekte! 
			Tamen nur tio: jen!
		</p>

		<p class="mb-3">
			Li montris al sia nuko.
		</p>

		<p class="mb-3">
			- Mi ne povas turni la kolon sen doloro. 
			Sed tio ne gravas. 
			Ĉio bonas, se oni komprenas; kaj mi komprenas.
		</p>

		<p class="mb-3">
			- Ĉu vi scias, kie vi troviĝas?
		</p>

		<p class="mb-3">
			- Kompreneble, doktoro! 
			Mi estas en frenezulejo. 
			Sed ja, se oni komprenas, tio tute ne gravas. 
			Tute ne gravas.
		</p>

		<p class="mb-3">
			La doktoro atenteme rigardis al liaj okuloj. 
			La bela, zorge flegita vizaĝo de la doktoro, kun perfekte kombita orkolora barbo kaj trankvilaj bluaj okuloj, rigardantaj tra ore kadritaj okulvitroj, estis senmova kaj senemocia. 
			Li observis.
		</p>

		<p class="mb-3">
			- Kial vi tiel atenteme rigardas min? 
			Vi ne povos tralegi tion, kio estas en mia animo, - daŭrigis la malsanulo, - sed mi klare legas en la via! 
			Por kio vi faras malbonon? 
			Por kio vi kunigis tiun aron da malfeliĉuloj kaj detenas ilin ĉi tie? 
			Por mi ne gravas: mi ĉion komprenas kaj estas trankvila; sed ili? 
			Por kio tiaj suferoj? 
			Por homo, kiu atingis tion, ke en lia animo estas granda ideo, ĝenerala ideo, por tiu homo ne gravas, kie vivi, kion senti. 
			Eĉ vivi kaj ne vivi… 
			Ĉu ne?
		</p>

		<p class="mb-3">
			- Eble, - respondis la doktoro, sidante sur la seĝon en angulo de la ĉambro tiamaniere, ke li povu vidi la malsanulon, kiu rapide paŝadis de unu angulo al alia, plandumante per enormaj pantofloj el ĉevala ledo kaj svingante baskojn de ĥalato el katuno, desegnita per larĝaj ruĝaj strioj kaj grandaj floroj. 
			La akompanintaj doktoron helpkuracisto kaj inspektisto daŭre staris rekte senmove apud la pordo.
		</p>

		<p class="mb-3">
			- Mi ja havas ĝin! 
			– eksklamis la malsanulo. 
			– Kaj kiam mi trovis ĝin, mi eksentis min renaskita. 
			La sensoj fariĝis pli akraj, la cerbo funkcias bone kiel neniam. 
			Kion antaŭe mi atingis per longa vojo de konkludoj kaj supozoj, nin venas al mi intuicie. 
			Mi reale atingis tion, kion la filozofio rezultigis kiel sian kronon. 
			Mi travivas en mi mem grandegajn ideojn pri tio, ke la spaco kaj tempo estas fikcioj. 
			Mi vivas en ĉiuj jarcentoj. 
			Mi vivas sen spaco, ĉie aŭ nenie, tutegale. 
			Kaj tial por mi ne gravas, ĉu vi detenas min ĉi tie aŭ forlasos, ĉu mi estas libera aŭ ŝnurligita. 
			Mi rimarkis, ke ĉi tie estas ankoraŭ kelkaj similaj personoj. 
			Sed por la ceteraj uloj tia stato estas terura. 
			Kial vi ne liberigu ilin? 
			Kiu bezonas…
		</p>

		<p class="mb-3">
			- Vi diris, - interrompis lin la doktoro, - ke vi vivas ekster la tempo kaj spaco. 
			Tamen, ne eblas ne konsenti, ke ni kun vi troviĝas en ĉi-ĉambro, kaj ke nun, - la doktoro elprenis la horloĝon, - estas duono antaŭ la dekunua de la 6-a de majo de 18… 
			jaro. 
			Kion vi opinias pri tio?
		</p>

		<p class="mb-3">
			- Nenion. 
			Por mi estas tutegale, kie esti kaj kiam vivi. 
			Kaj se por mi estas tutegale, ĉu ne signifas tio, ke mi estas ĉie kaj ĉiam?
		</p>

		<p class="mb-3">
			La doktoro ironie ridetis.
		</p>

		<p class="mb-3">
			- Rara logiko, - diris li ekstarante. 
			– Probable, vi pravas. 
			Ĝis la revido. 
			Ĉu deziras vi la cigaron?
		</p>

		<p class="mb-3">
			- Mi dankas vin. 
			– La malsanulo haltis, prenis la cigaron kaj nervoze formordis ĝian pinton. 
			– Tio helpas pensi, - diris li. 
			– Tio estas mondo, mikrokosmo. 
			Sur unu ekstremo – alkaloj, sur aliu – acidoj. 
			Ankaŭ la mondo havas la saman ekvilibron, en kiu neŭtraligas sin la kontraŭaj entoj. 
			Adiaŭ, doktoro!
		</p>

		<p class="mb-3">
			La doktoro daŭrigis sian vojon. 
			La plimulto de malsanuloj atendis lin starante rekte senmove apud siaj litoj. 
			Neniu estro ĝuas tian adoradon de siaj subuloj, kiel doktoro-psikiatro de siaj frenezuloj.
		</p>

		<p class="mb-3">
			Sed la malsanulo, restinte sola, ne ĉesis sian impetan paŝadon de unu angulo de la kamero al la alia. 
			Oni alportis al li teon; li sen sidiĝi, en du glutoj malplenigis grandan tason kaj preskaŭ momente formanĝis grandan pecon da blanka pano. 
			Poste li foriris el la ĉambro kaj kelkajn horojn senhalte paŝadis per sia rapida kaj peza paŝmaniero de unu ekstremo de la domo ĝis la kontraŭa. 
			La tago estis pluvoza, kaj oni ne lasis la malsanulojn eliri al ĝardeno. 
			Kiam la helpkuracisto komencis serĉi la novan malsanulon, oni montris al la fino de la koridoro; li staris tie, algluinte la vizaĝon al la vitra pordo, kondukanta al ĝardeno, kaj fikse rigardis la florbedon. 
			Lian atenton altiris neordinare hela skarlata floro, unu el specioj de papavo.
		</p>

		<p class="mb-3">
			- Bonvolu vin pesi, - diris la helpkuracisto, tuŝante lian ŝultron.
		</p>

		<p class="mb-3">
			Sed kiam tiu sin turnis al li sian vizaĝon, li preskaŭ forsaltis timeme: tiom da sovaĝa malamo kaj malico brilis en rabiaj okuloj. 
			Sed ekvidinte la helpkuraciston, li tuj ŝanĝis la mienon kaj obeeme sekvis lin senvorte, kvazaŭ profunde enpensiĝinta. 
			Ili eniris en la doktoran kabineton; la malsanulo mem surpaŝis sur la plataĵon de negranda dekonskala pesilo; la helpkuracisto post pesigo notis en la registra libro kontraŭ lia nomo: 109 funtojn. 
			En la sekva tago estis 107, en la tria – 106.
		</p>

		<p class="mb-3">
			- Se tiel statos plu, li ne restos viva, - diris la doktoro kaj ordonis nutri lin kiel eble plej bone. 
		</p>

		<p class="mb-5">
			Sed malgraŭ tio kaj malgraŭ eksterordinara apetito de la malsanulo, li maldikiĝis ĉiutage, kaj la helpkuracisto ĉiutage notis en la registra libro ĉiam pli kaj pli malgrandan nombron de funtoj. 
			La malsanulo apenaŭ dormis kaj la tutajn tagojn pasigis en senĉesa movado.
		</p>


		<p class="mb-5 mt-5 text-center bold">4</p>


		<p class="mb-3">
			li konsciis, ke li estas en malsanulejo; li konsciis eĉ, ke li malsanas. 
			Foj-de-foje, same kiel la unuan nokton, li vekiĝadis en silento post la tuta tago de impeta movado, sentante obtuzan doloron en la tuta korpo kaj teruran pezon en la kapo, sed plenkonscia. 
			Eble, la foresto de impresoj en la nokta silento kaj duonlumo, eble, la febla funkciado de la cerbo en la ĵus vekiĝinta homo kaŭzis, ke li en tiaj momentoj klare komprenis sian staton kaj, ŝajne, estis sana. 
			Sed venadis la tago; kune kun la lumo kaj revigliĝo en la malsanulejo lin denove inundis impresoj; la malsana cerbo ne povis submeti ilin, kaj li denove fariĝis aliena. 
			Lia stato estis stranga miksaĵo de ĝustaj konkludoj kaj absurdaĵoj. 
			Li komprenis, ke ĉirkaŭ li ĉiuj estas malsanaj; sed samtempe, en ĉiu el ili li vidis iun sekrete kaŝantan sin aŭ kaŝitan personon, kiun li konis antaŭe aŭ pri kiu li aŭdis aŭ legis. 
			La malsanulejo estis loĝigita de la homoj el ĉiuj tempoj kaj ĉiuj landoj. 
			Tie estis kaj vivaj, kaj mortintaj. 
			Tie estis famuloj kaj potenculoj de la mondo – kaj soldatoj, mortigitaj dum la lasta milito kaj resurektintaj. 
			Li vidis sin en iu mistera, sorĉa cirklo, kuniginta la tutan teran forton, kaj en orgojla deliro li konsideris sin mem la centro de tiu cirklo. 
			Ĉiuj ili, liaj kunuloj-malsanuloj, kolektiĝis ĉi tie por plenumi aferon, kiun li svage perceptis kiel kolosa entrepreno destinita por neniigi la malbonon sur la tero. 
			Li ne sciis, kion li devos fari, sed sentis en si sufiĉe da fortoj por plenumi tion. 
			Li povis legi la pensojn de aliuj homoj; vidis la tutan antaŭhistorion de aĵoj; la grandaj ulmoj en la malsanuleja ĝardeno rakontis al li ravajn legendojn el siaj vivoj; la domon, efektive konstruitan sufiĉe antaŭlonge, li opiniis la samtempulo de Petro la Granda kaj estis certa, ke la caro loĝis en ĝi dum la epoko de Poltava batalo. 
			Li tralegis tion sur muroj, sur forfalinta ŝtukaĵo, sur la pecoj de brikoj kaj kaheloj, trovitaj de li en la ĝardeno; la tuta historio de la domo kaj ĝardeno estis notita sur ili. 
			Li loĝigis malgrandan konstruaĵon de kadavrejo per dekoj kaj centoj da delonge mortintaj homoj kaj atente fiksrigardis fenestreton de ĝia kelo, kiu videblis en unu anguleto de l’ ĝardeno, observante en glima lumrebrilo sur malnova iriza kaj malpura vitro la konatajn trajtojn, iam viditajn de li reale aŭ sur portretoj.
		</p>

		<p class="mb-3">
			Intertempe venis bona, bela vetero; la malsanuloj pasigis la tutajn tagojn ekstere, en ĝardeno. 
			En ilia parto de la ĝardeno, negranda, sed plenplena de arboj, ĉie kie eble estis plantitaj floroj. 
			La inspektisto devigis labori tie ĉiujn iom-tiom kapablajn por laboro; la tutajn tagojn ili balaadis kaj surŝutadis per sablo padetojn, sarkadis kaj akvumadis bedojn kun floroj, kukumoj, akvomelonoj kaj melonoj; tiujn bedojn ili mem same zorgeme prifosadis antaŭe.
		</p>

		<p class="mb-3">
			En la angulo de l’ ĝardeno dense kreskis ĉerizaro; laŭlonge de ĝi etendiĝis ulmaj aleoj; meze, sur negranda artefarita monteto, estis plantita la plej bela florejo en la tuta ĝardeno; helaj floroj kreskis laŭrande de la supra plateto, kaj en ĝia centro paradis alta, granda kaj rara, flava kun ruĝaj punktetoj dalio. 
			Ĝi formis ankaŭ la centron de la tuta ĝardeno, altiĝante super ĝi, kaj estis rimarkeble, ke multaj malsanuloj atribuis al ĝi iun apartan, misteran signifon. 
			Ankaŭ al la nova malsanulo ĝi ŝajnis io ne tro ordinara, iu supera protektanto de la domo kaj ĝardeno. 
			Ĉiuj padetoj ankaŭ estis ornamitaj de plantoj far malsanuloj. 
			Tie kreskis plej diversaj floroj, kiujn oni povas renkonti en ukrainiaj ĝardenetoj: altaj rozoj, helaj petunioj, arbedoj de alta tabako kun malgrandaj rozkoloraj floroj, mentoj, tagetoj, tropeoloj kaj papavoj. 
			En la sama loko, apud peroneto, kreskis tri papavoj de iu speciala raso: ili estis multe pli malgrandaj ol la kutimaj kaj distingiĝis per ekstreme hela skarlata koloro. 
			Ĝuste tiu floro tiel impresis la malsanulon kiam li la unuan tagon post sia alveno al la malsanulejo rigardis al la ĝardeno tra vitra pordo.
		</p>

		<p class="mb-3">
			Elirinte la unuan fojon al la ĝardeno, li tuj, ankoraŭ ne descendinte de la ŝtupoj de la peroneto, ekrigardis al tiuj helaj floroj. 
			Da ili estis nur du; hazarde ili kreskis aparte de la aliuj kaj sur nesarkita loko, tiel ke dense kreskanta atriplo kaj iuj loloj ĉirkaŭis ilin.
		</p>

		<p class="mb-3">
			La malsanuloj unu post alia eliradis el la pordo, ĉe kiu staris gardisto kaj donadis al ĉiu po dika, blanka, trikita el kotono ĉapo kun ruĝa kruco surfrunte. 
			Tiuj ĉapoj iam apartenis al milita ekipaĵo kaj estis aĉetitaj en aŭkcio. 
			Sed la malsanulo, kompreneble, atribuis al tiu ruĝa kruco apartan, misteran signifon. 
			Li forprenis sian ĉapon kaj rigardis la krucon kaj poste la florojn de papavo. 
			La floroj estis pli helaj.
		</p>

		<p class="mb-3">
			- Li venkas, - diris la malsanulo, - sed ni ekvidos…
		</p>

		<p class="mb-3">
			Kaj li descendis de la peroneto. 
			Ĉirkaŭrigardinte kaj ne rimarkinte la gardiston, starantan post lia dorso, li transpaŝis la florbedon kaj etendis la manon al la floro, sed ne arogis pluki ĝin. 
			Li eksentis febron kaj lancinon en la etendita mano, kaj poste jam en la tuta korpo, kvazaŭ iu forta emanaĵo de nekonata naturo elfluis el la ruĝaj petaloj kaj trapenetris tutan lian korpon. 
			Li alproksimiĝis kaj etendis la manon al la floro mem, sed la floro, ŝajnis al li, defendis sin, eligante venenan, mortigan spiron. 
			Lia kapo komencis turniĝi; li faris lastan furiozan penon kaj jam estis kaptanta la tigeton, kiam subite peza mano premis lian ŝultron. 
			La gardisto kaptis lin.
		</p>

		<p class="mb-3">
			- Estas malpermesite pluki, - diris la maljuna ukrainano. 
			– Kaj la florbedon ne surtretu. 
			Ĉi tie multaj da vi, frenezuloj, troviĝas; se ĉiu po floro – oni la tutan ĝardenon pereigos, - konvinkige diris li, ankoraŭ tenante lian ŝultron.
		</p>

		<p class="mb-3">
			La malsanuo rigardis al lia vizaĝo, senvorte liberiĝis de lia brako kaj maltrankvile ekpaŝis tra l’ vojeto. «Ho, malfeliĉuloj! 
			– pensis li. 
			– Vi ne vidas, vi tiomgrade blindiĝis, ke eĉ defendas ĝin. 
			Sed malgraŭ ĉio, mi metos finon al ĝi. 
			Se ne hodiaŭ, do morgaŭ ni komparos niajn fortojn en batalo. 
			Kaj se mi mortos tiam, ĉu gravas…»
		</p>

		<p class="mb-3">
			Li promenis tra la ĝardeno ĝis la malfrua vespero, farante konatiĝojn kaj komencante strangajn konversaciojn, en kiuj ĉiu el kunparolantoj aŭdis nur respondojn al siaj bizaraj ideoj, esprimitajn per absurde-misteraj frazoj. 
			La malsanulo promenis kune jen kun unu samsortano, jen kun aliu, kaj ĉe la fino de l’ vespero eĉ pli firme konvinkiĝis, ke «ĉio pretas», kiel li diris al si mem. 
			Baldaŭ, baldaŭ disfalos feraj kradoj, ĉiuj tiuj enkarcerigitaj uloj eliros de ĉi tie kaj ekkuregos al ĉiuj partoj de la tero, kaj la tuta mondo ektremos, forskuos de si la kadukan ŝelon kaj aperos en nova, raviga beleco. 
			Li preskaŭ forgesis pri la floro, sed, forirante de l’ ĝardeno kaj suprenirante peroneton, li denove ekvidis en la densa, malheliĝinta kaj jam kovrita per unua roso herbo kvazaŭ du ardajn braĝojn. 
			Tiam la malsanulo iom haltis, apartiĝis de la tumulto kaj kaŝinte sin post la dorso de l’ gardisto, kaptis la konvenan momenton. 
			Neniu vidis, kiel li transsaltis la florbedon, ŝiris la floron kaj haste kaŝis ĝin sur sia brusto sub ĉemizon. 
			Kiam la freŝaj roskovritaj petaloj tuŝis lian korpon, li morte paliĝis kaj en teruro larĝe malfermis la okulojn. 
			Malvarma ŝvito aperis sur lia frunto.
		</p>

		<p class="mb-3">
			En la malsanulejo oni lumigis lampojn; atendante vespermanĝon, plimulto da malsanuloj ekkuŝis sur litojn, krom kelkaj maltrankviluloj, haste paŝantaj tra la koridoro kaj haloj. 
			La malsanulo kun la floro estis inter ili. 
			Li paŝadis, spasme interkruciginte la brakojn sur sia brusto; ŝajnis, ke li volis dispremi, dismueli la kaŝitan surbruste floron. 
			Renkontante aliujn homojn, li singarde ĉirkaŭiris ilin, timante eĉ tuŝi ilin per vestorando. «Ne proksimiĝu, ne proksimiĝu!» – kriis li. 
			Sed en la malsanulejo nemultaj atentis tiajn avertojn. 
			Kaj li paŝadis pli kaj pli rapide, faris paŝojn pli kaj pli larĝajn, paŝis horon, duan kun iu febra ekscitiĝo.
		</p>

		<p class="mb-3">
			- Mi lacigos vin! 
			Mi sufokigos vin! 
			– kun obtuza malamo li estis diranta.
		</p>

		<p class="mb-3">
			Iam li grincis per dentoj.
		</p>

		<p class="mb-3">
			En la manĝejo oni servis vespermanĝon. 
			Sur longajn tablojn sen tablotukoj oni metis po kelkaj lignaj farbitaj kaj orumitaj bovloj kun akvoza milia kaĉo; la malsanuloj eksidis sur benkojn; oni disdonis al ĉiu el ili po peco da nigra pano. 
			Manĝis ili per lignaj kuleroj, okope el unu bovlo. 
			Kelkiuj, ĝuantaj plibonigitan dieton, estis servitaj aparte. 
			Nia malsanulo, rapide englutinte sian porcion, alportitan de l’ gardisto, kiu vokis lin en lian ĉambron, ne kontentiĝis per tio kaj venis al komuna manĝejo.
		</p>

		<p class="mb-3">
			- Permesu al mi eksidi ĉi tie, - diris li al la inspektisto.
		</p>

		<p class="mb-3">
			- Ĉu vi ne jam manĝis? 
			– demandis la inspektisto, plenigante bovlojn per aldonaj porcioj de kaĉo.
		</p>

		<p class="mb-3">
			- Mi estas tre malsata. 
			Kaj mi bezonas signife plifortigi min. 
			La tuta mia subteno estas manĝaĵo; vi scias ja, ke mi tute ne dormas.
		</p>

		<p class="mb-3">
			- Bonvolu manĝi, karulo, por via sano. 
			Taras’, donu al la moŝtulo kuleron kaj panon.
		</p>

		<p class="mb-3">
			Li alsidiĝis al unu el bovloj kaj formanĝis ankoraŭ grandegan kvanton da kaĉo.
		</p>

		<p class="mb-3">
			- Nu, sufiĉas, sufiĉas, - diris fin-fine la inspektisto, kiam ĉiuj jam finis vespermanĝi, sed nia malsanulo daŭre sidis ĉe la bovlo, ĉerpante el ĝi per unu mano la kaĉon, kaj per alia firme alpremante sian bruston. 
			– Vi tromanĝos.
		</p>

		<p class="mb-3">
			- Ho, se vi scius, kiom da fortoj mi bezonas, kiom da fortoj! 
			Adiaŭ, Nikolaj Nikolajiĉ, - diris la malsanulo, ekstarante de la tablo kaj firme premante la manon de la inspektisto. 
			– Adiaŭ.
		</p>

		<p class="mb-3">
			- Kien do vi? 
			– demandis la inspektisto kun rido.
		</p>

		<p class="mb-3">
			- Mi? 
			Nenien. 
			Mi restas. 
			Sed eble, morgaŭ ni ne revidos unu la alian. 
			Mi dankas vin pro via bonkoreco.
		</p>

		<p class="mb-3">
			Kaj li denove firme mansalutis la inspektiston. 
			Lia voĉo tremis, sur okuloj aperis larmoj.
		</p>

		<p class="mb-3">
			- Trankviliĝu, kara, trankviliĝu, - respondis la inspektisto. 
			– Por kio tiaj mornaj pensoj? 
			Vi iru, kuŝiĝu kaj ekdormu profunde. 
			Al vi endus dormi pli longe; se vi bone dormus, do resaniĝos ja baldaŭ.
		</p>

		<p class="mb-5">
			La malsanulo ploregis. 
			La inspektisto forturnis sin por ordoni al gardistoj pli rapide forpreni la restaĵojn de l’ vespermanĝo. 
			Post duonhoro en la malsanulejo jam ĉio dormis, krom unu persono, vestite kuŝanta sur lito en la angula ĉambro. 
			Li tremis kvazaŭ en deliro kaj spasme kunpremis sian bruston, kiu ŝajnis al li tute saturita de neimageble mortiga veneno.
		</p>


		<p class="mb-5 mt-5 text-center bold">5</p>


		<p class="mb-3">
			La tutan nokton li ne dormis. 
			Li ŝiris tiun floron, ĉar li vidis en tiu ago la heroaĵon, kiun li estis devigita fari. 
			Jam dum la unua rigardo trans vitra pordo la skarlataj petaloj allogis lian atenton, kaj li imagis, ke ekde tiu momento li tute ekkomprenis, kion ĝuste li devas okazigi sur la tero. 
			En tiu brila ruĝa floro akumuliĝis la tuta malbono de la mondo. 
			Li sciis, ke el papavo oni produktas opion; eble, tiu penso, kreskante kaj monstre transformiĝante, influis lin krei timigan fantomon. 
			La floro en lia imago enkarnigis en si la tutan malbonon; ĝi ensorbis la tutan senkulpe verŝitan sangon (kaj tial do ĝi estis tiom ruĝa), la tutajn larmojn, tutan galon de la homaro. 
			Ĝi estis mistera horora estaĵo, la mal-Dio, Arimano, surmetinta modestan kaj senkulpan aspekton. 
			Estis necese ŝiri ĝin kaj mortigi. 
			Sed ne nur tio: necesis ne lasi ĝin dum agonio elverŝi la tutan sian malbonon al la mondo. 
			Tial li kaŝis la floron ĉe sia brusto. 
			Li esperis, ke ĝis mateno la floro perdos tutan sian forton. 
			Ĝia malamo venos al lia brusto, al lia animo kaj tie aŭ estos venkita, aŭ venkos. 
			Tiam li mem pereos, mortos – sed mortos kiel honesta batalanto, kaj kiel unua batalanto de la homaro, ĉar ĝis nun neniu arogis batali per unu fojo kontraŭ la tuta monda malbono kune.
		</p>

		<p class="mb-3">
			- Ili ne vidis ĝin. 
			Mi ekvidis. 
			Ĉu mi rajtas lasi ĝin vivi? 
			Prefere mi mortu.
		</p>

		<p class="mb-3">
			Kaj li kuŝis, senfortiĝante en fantoma, nereala batalo, sed tamen senfortiĝante. 
			Matene la helpkuracisto trovis lin apenaŭ viva. 
			Sed malgraŭ tio, post kelka tempo la ekscitiĝo superis, li eksaltis de la lito kaj kiel antaŭe komencis kuradi tra l’ malsanulejo, parolante al malsanuloj kaj al si mem eĉ pli laŭte kaj pli senorde ol iam ajn. 
			Oni ne lasis lin eniri en la ĝardenon; la doktoro, vidante, ke lia pezo malpliiĝas, sed li konstante ne dormas kaj konstante paŝadas, ordonis injekti al li subhaŭte grandan dozon de morfino. 
			Li ne kontraŭstaris; feliĉe, dum tiu tempo liaj frenezaj pensoj iel koincidis kun tiu operacio. 
			Li rapide ekdormis; la febra movado haltis, kaj konstante akomponanta ĝin, naskita el la takto de liaj impetaj movoj laŭta motivo malaperis el liaj oreloj. 
			Li dronis en dormon kaj ĉesis pensi pri ĉio, eĉ pri la dua floro, ankaŭ ŝirenda.
		</p>

		<p class="mb-3">
			Tamen li ŝiris ĝin post tri tagoj, antaŭ la okuloj de l’ maljunulo, kiu ne sukcesis preventi lin. 
			La gardisto persekutis lin. 
			Kun laŭta jubila kriego la malsanulo elanis en la malsanulejon kaj impete enkurinte en sian ĉambron, kaŝis la floron ĉe sia brusto.
		</p>

		<p class="mb-3">
			- Kial vi ja florojn ŝiras? 
			– demandis la hastinta post li gardisto. 
			Sed la malsanulo, jam kuŝanta sur la lito en la kutima pozicio kun krucumitaj brakoj, komencis paroli tian absurdaĵon, ke la gardisto nur senvorte forprenis de lia kapo la forgesitan en hasta fuĝo ĉapon kun ruĝa kruco kaj foriris. 
			La fantoma batalo komenciĝis denove. 
			La malsanulo sentis, ke el la floro per longaj serpentumantaj tentakloj rampas malbono; tiuj tentakloj ĉirkaŭligis lin, kunpremis kaj kuntiris la membrojn kaj saturigis la korpon per sia terura entenaĵo. 
			Li ploris kaj preĝis al Dio intermite de damnoj al sia malamiko. 
			Ĝis vespero la floro velkis. 
			La malsanulo dispremis piede la nigriĝintan planton, prenis la restaĵojn de la planko kaj alportis al la banejo. 
			Ĵetinte la senforman buleton de verdaĵo al ardigita per ŝtonkarbo stovo, li longe spektis, kiel lia malamiko siblis, ŝrumpis kaj fin-fine transformiĝis en delikatan neĝoblankan buleton de cindro. 
			Li blovis, kaj ĉio malaperis.
		</p>

		<p class="mb-3">
			Sekvatage la stato de la malsanulo malpliboniĝis. 
			Terure pala, kun kaviĝintaj vangoj kaj akre brilantaj el profundaj orbitoj okuloj, li, jam ŝanceliĝante kaj ofte stumblante, daŭrigis sian rabian paŝadon kaj parolis, parolis senĉese.
		</p>

		<p class="mb-3">
			- Mi ne volus uzi perforton, - diris al sia helpanto la ĉefdoktoro.
		</p>

		<p class="mb-3">
			- Sed necesas ja halti tiun laboron. 
			Nun li pezas 93 funtojn. 
			Se tiel daŭros, li mortos post du tagoj.
		</p>

		<p class="mb-3">
			La ĉefdoktoro enpensiĝis.
		</p>

		<p class="mb-3">
			- Morfino? 
			Kloralo? 
			– diris li duondemande.
		</p>

		<p class="mb-3">
			- Hieraŭ la morfino jam ne efikis.
		</p>

		<p class="mb-5">
			- Ordonu, ke oni ŝnurligu lin. 
			Tamen, mi dubas, ke li restos viva.
		</p>


		<p class="mb-5 mt-5 text-center bold">6</p>


		<p class="mb-3">
			Kaj oni ŝnurligis la malsanulon. 
			Li kuŝis, vestita en frenezulan ĉemizon, sur sia lito, firme alligita per larĝaj tolaj strioj al feraj traboj de la lito. 
			Sed la furiozeco de la movoj ne malpliiĝis, sed eĉ potenciĝis. 
			Dum multaj horoj li obstine provis liberiĝi de siaj katenoj. 
			Fin-fine, foje, post fortega elano, li disŝiris unu el siaj vindaĵoj, liberigis la gambojn kaj, elglitinte el-sub aliuj tolstrioj, 
			kun ŝnurligitaj brakoj komencis paŝadi en la ĉambro, elkriante sovaĝajn, nekompreneblajn vortojn.
		</p>

		<p class="mb-3">
			- Ho, prenu vin!.. 
			– ekkriis la enirinta gardisto en sia popola lingvaĵo. 
			– Kia diablo helpas vin! 
			Gricko! 
			Ivan! 
			Venu rapide, ĉar li malligiĝis.
		</p>

		<p class="mb-3">
			Ili triope sin ĵetis al la malsanulo, kaj komenciĝis longa batalo, laciga por la atakantoj kaj turmentiga por la defendanto, kiu elspezadis la reston de siaj jam konsumitaj fortoj. 
			Fin-fine oni faligis lin surliten kaj ŝnurligis eĉ pli firme.
		</p>

		<p class="mb-3">
			- Vi ne komprenas, kion vi faras! 
			– kriis la malsanulo anhelante. 
			– Vi estas pereontaj! 
			Mi vidis la trian, apenaŭ ekflorintan. 
			Nun ĝi jam pretas. 
			Lasu min fini la aferon! 
			Necesas mortigi ĝin, mortigi, mortigi! 
			Tiam ĉio estos finita, ĉio savita! 
			Mi sendus vin, sed tion povas fari nur mi sola. 
			Vi mortus pro la unua ĝia tuŝo.
		</p>

		<p class="mb-3">
			- Silentu, sinjoreto, silentu! 
			– diris en la sama lingvo la maljunulo-gardisto, kiu restis deĵori ĉe lia lito.
		</p>

		<p class="mb-3">
			La malsanulo subite eksilentis. 
			Li decidis trompi la gardistojn. 
			Oni tenis lin ŝnurligita dum la tuta tago kaj lasis en la sama stato por la nokto. 
			Doninte al li vespermanĝon, la gardisto sternis ion apud la lito kaj ekkuŝis. 
			Post momento li jam profunde dormis, kaj la malsanulo ekis la laboron.
		</p>

		<p class="mb-3">
			Li kurbiĝis per la tuta sia korpo por tuŝi la feran transversan trabon de la lito, kaj trovinte ĝin per la volvita en longan manikon de l’ frenezula ĉemizo mano, komencis rapide kaj forte froti la manikon kontraŭ la feraĵo. 
			Post kelka tempo la dika veltolo cedis, kaj li liberigis la montran fingron. 
			Nun la afero plifaciliĝis. 
			Kun la fleksebleco kaj lerteco, tute neimagebla por la sana homo, li malnodis sur la dorso la nodon de manikoj, disŝnuris la ĉemizon kaj poste longe atente aŭskultis la ronkadon de l’ gardisto. 
			Sed la maljunulo dormis profunde. 
			La malsanulo demetis la ĉemizon kaj deligis sin de la lito. 
			Li estis libera. 
			Li kontrolis la pordon: ĝi estis ŝlosita deinterne, kaj la ŝlosilo, verŝajne, kuŝis en la poŝo de l’ gardisto. 
			Pro timo veki, li ne arogis traserĉi la poŝojn kaj decidis foriri el la ĉambro tra fenestro.
		</p>

		<p class="mb-3">
			Estis kvieta, varma kaj obskura nokto; la fenestro estis malfermita; la steloj brilis sur nigra ĉielo. 
			Li rigardis al ili, rimarkante konatajn konstelaciojn kaj ĝojante, ke ili, ŝajnis al li, komprenas kaj aprobas lin. 
			Palpebrumante, li vidis senfinajn radiojn, kiujn ili sendis al li, kaj lia aŭdaca decidemo kreskis. 
			Estis necese deklini dikan feran stangon de la krado, alrampi tra malvasta fendo al fora anguleto, tutkovrita de arbustoj, kaj transgrimpi altan ŝtonan barilon. 
			Tie okazos la lasta batalo, kaj poste – estu eĉ morto.
		</p>

		<p class="mb-3">
			Li provis forklini la dikan stangon per nuraj manoj, sed la feraĵo ne cedis. 
			Tiam, tordinte el firmtolaj manikoj de la frenezula ĉemizo ŝnuregon, li alkroĉis ĝin al la sagforma pinto de la stango kaj per la tuta sia pezo alpendiĝis al ĝi. 
			Post neimagebla streĉiĝo, preskaŭ konsuminta la reston de liaj fortoj, la sagpinto fleksiĝis; la malvasta trairejo estis malfermita. 
			Li trapuŝis sin tra ĝi, skrapvundinte siajn ŝultrojn, kubutojn kaj nudajn genuojn, trapenetris tra arbustoj kaj haltis antaŭ la muro. 
			Ĉio silentis ĉirkaŭe; la flamoj de noktolampoj apenaŭ lumigis deinterne fenestrojn de la grandega konstruaĵo; neniu videblis en ili. 
			Neniu rimarkis lin; la maljunulo, deĵoranta apud lia lito, verŝajne profunde dormis. 
			La steloj karese trembrilis per radioj, kiuj penetris lin ĝis la koro mem.
		</p>

		<p class="mb-3">
			- Mi iras al vi, - flustris li, rigardante al ĉielo.
		</p>

		<p class="mb-3">
			Falinte teren post la unua provo, kun forŝiritaj ungoj, sangantaj manoj kaj genuoj, li persiste serĉis oportunan lokon. 
			Tie, kie la barilo kuniĝis kun la muro de l’ kadavrejo, el ĝi kaj el la muro elfalis kelkaj brikoj. 
			La malsanulo ekpalpis tiujn kavaĵojn kaj ekuzis ilin. 
			Li surgrimpis la barilon, ekkaptis la branĉojn de ulmo kreskinta trans la barilo kaj senbrue malsupreniĝis laŭ la arbotrunko teren.
		</p>

		<p class="mb-3">
			Li impetis al la konata loko apud peroneto. 
			La malhela kapeto de la floro, kun ĝiaj kuntiritaj petaloj, klare distingiĝis sur la fono de roskovrita herbo.
		</p>

		<p class="mb-3">
			- La lasta! 
			– flustris la malsanulo. 
			– La lasta! 
			Hodiaŭ – la venko aŭ la morto. 
			Sed por mi tio jam ne gravas. 
			Atendu, - diris li, rigardante al ĉielo, - Mi baldaŭ estos kun vi.
		</p>

		<p class="mb-3">
			Li elŝiris la planton, torturis ĝin, plenĉifis kaj, tenante ĝin en la mano, per la sama vojo revenis al la ĉambro. 
			La maljunulo dormis. 
			La malsanulo, pene atinginte la liton, falegis al ĝi senkonscia.
		</p>

		<p class="mb-3">
			Matene oni trovis lin morta. 
			La vizaĝo lia estis trankvila kaj hela; la inanicia fizionomio, kun magraj lipoj kaj profunde enkaviĝintaj fermitaj okuloj, esprimis iun fieran feliĉon. 
			Kiam oni metis lin sur la brankardon, oni provis malfleksi la fingrojn kaj forpreni la ruĝan floron. 
			Sed la mano rigidiĝis, kaj li portis sian trofeon al la tombo.
		</p>
		`
	)
}

const itemName = {
	esp: 'Vsevolod Garŝin. La ruĝa floro'
}

const item = {
	itemlink: getLink(itemName.esp),
	esp: {
		itemName: itemName.esp,
		itemContent: content.esp,
		itemAuthor: 'Vsevolod Garŝin',
		itemTranslator: translator.esp
	}
}

export default item;